export default __webpack_public_path__ + "static/media/Correa.a6cc009f.jpg";